module.exports = __webpack_public_path__ + "assets/images/undo-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/undo-icon.png
// module id = 119
// module chunks = 1